import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';

// The shell each of the town's trades is served through: a titled panel with
// the party's purse in the corner, and Escape to step back into the street.
// `onKey` lets a trade take the number keys for its own list.
class FacilityFrame extends Component {

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = (e) => {
    if (e.key === 'Escape') {
      this.props.context.closeFacility();
      return;
    }
    if (this.props.onKey) this.props.onKey(e);
  }

  render() {
    const { title, quote, hint, children, context } = this.props;

    return (
      <div id="trainingHall">
        <div className="training-panel">
          <div className="sheet-header">
            <div>
              <h1>{title}</h1>
              <div className="sheet-subtitle">{quote} · {context.gold} gold</div>
            </div>
            <div className="sheet-close" onClick={context.closeFacility}>LEAVE (ESC)</div>
          </div>

          {children}

          {hint && <div className="sheet-hint">{hint}</div>}
        </div>
      </div>
    );
  }
}

export default withContext(FacilityFrame);
